import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";

function SupertestIntro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100 bg-preguntas-5">
			<div className="container-fluid pt-4 h-100">
				<div className="row h-100">
					<div
						className="col d-flex justify-content-center align-items-center"
						style={{ marginBottom: "30vh" }}
					>
						<div className="d-flex flex-column align-items-center mt-2">
							<div>
							</div>
							<div className="txt30 txt-purple bold mt-4 pt-2">
								SUPERTEST
							</div>
							<div className="mt-4 pt-2">
								<NextButton
									navigateTo={ROUTES.SUPERTEST_INSTRUCTIONS}
									activeScenario={activeScenario}
								></NextButton>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(SupertestIntro);
